import React from 'react'
import type { CategoryTree } from '@pylot-data/pylotschema'
import s from '@corratech/air-ooka-header/Menu/DesktopMenu/DesktopMenu.module.scss'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import Link from '@corratech/pylot-ui/src/Link'
import { Maybe } from '@pylot-data/pylotschema'
import cn from 'classnames'
import { OtherMenuItem } from '@corratech/air-ooka-header/Menu/DesktopMenu/OtherMenuItem'
import { useTopNavTracking } from '@corratech/pylot-tag-manager/src/hooks/useMenuTracking'

type DesktopMenuProps = {
    category: CategoryTree
}

export const sortCategories = (
    a: Maybe<CategoryTree>,
    b: Maybe<CategoryTree>
): number => {
    if (!a?.position || !b?.position) {
        return 0
    }
    return a.position - b.position
}

export const DesktopMenu = ({
    category
}: DesktopMenuProps): JSX.Element | null => {
    const categories = category?.children
    const { base } = useStoreConfig()
    const trackMenuClick = useTopNavTracking()

    if (!categories?.length) return null

    categories.sort(sortCategories)

    const handleMenuClick = (cat: Maybe<CategoryTree>) => {
        if (!cat) return
        const url = `/${base.url.model.category.directory}/${cat.url_key}`
        trackMenuClick(cat.name as string, url, [cat.url_key as string])
    }

    return (
        <div className={cn(s['DesktopMenuMain'], 'menuDesktopMobileWrapper')}>
            {categories.map((cat) => {
                if (!cat?.include_in_menu) return null
                return (
                    <Link
                        key={cat.url_key}
                        className={s['MainMenuLink']}
                        href={`/${base.url.model.category.directory}/${cat.url_key}`}
                        onClick={() => handleMenuClick(cat)}
                    >
                        <span>{cat.name}</span>
                    </Link>
                )
            })}
            <OtherMenuItem />
        </div>
    )
}

export default DesktopMenu
